import firebaseApp from "../../firebase/credenciales";
import React from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

//const {contextData} = useDataContext();
    

export default async function getProductos_manifiesto(producto) {
    

  console.log(producto);
    const productos_manifiestoDB =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Manifiestos/Tarimas/"+producto.manifiesto+"/".replace(/ /g, ""));
    console.log(collectionRef)
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      productos_manifiestoDB.push(doc.data());
    });
    return productos_manifiestoDB;
    

}


//"+productofolio+"
